import { bytesToNDigits } from '@mail/cross-sizes-utils';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { BuyContent } from 'reactApp/components/BuyModal/BuyContent';
import { BuyModalTrial } from 'reactApp/components/BuyModalTrial/BuyModalTrial';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { Dialog } from 'reactApp/ui/Dialog/Dialog';
import { EPaymentGa, sendPaymentGa } from 'reactApp/utils/paymentGa';
import { sendTmrGoal } from 'reactApp/utils/tmr';

import { IMapState, IOwnProps, IState, ISubscription, Props } from './BuyModal.types';

const mapStateToProps = (state: IState, props: IOwnProps): IMapState => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const subscription = ProductsSelectors.getProductById(state, props.id) as ISubscription;
    const { total: userTotalSpace } = UserSelectors.getCloudSpace(state);

    return {
        subscription,
        userTotalSpace,
    };
};

export class BuyModalComponent extends PureComponent<Props, IState> {
    subscriptionSpace = this.props.subscription && this.props.subscription.space;
    userSpace = this.props.userTotalSpace;

    state = {
        isSuccess: false,
    };

    componentDidMount(): void {
        this.sendPayment({ label: 'view' });
    }

    sendPayment = ({ label }) => {
        const { subscription, id } = this.props;

        if (subscription.hasTrial) {
            return;
        }

        sendPaymentGa({ action: EPaymentGa.payment, label, tariff: id });
    };

    renderHeader = (): JSX.Element | null => {
        const { renew, subscription } = this.props;

        const newSpace = bytesToNDigits(this.userSpace.original + this.subscriptionSpace.original, 3).value;

        if (this.state.isSuccess) {
            if (renew) {
                return <div>Вы продлили тариф на {this.subscriptionSpace.value}</div>;
            }
            return <div>Вы увеличили квоту до {newSpace}</div>;
        }

        if (renew) {
            return <div>Продление периода тарифа на {this.subscriptionSpace.value}</div>;
        }

        if (subscription.hasTrial) {
            return <div>Введите данные карты</div>;
        }

        return <div>Увеличение объёма до {newSpace}</div>;
    };

    onBuyClick = () => {
        this.sendPayment({ label: 'click' });
    };

    onSuccess = (): void => {
        const { subscription, onSuccess } = this.props;

        sendTmrGoal({ goal: subscription.hasTrial ? 'trial-success' : 'pay-success' });

        this.setState({ isSuccess: true });

        onSuccess();
    };

    onClose = (): void => {
        const { onClose } = this.props;

        onClose();
    };

    onCancelDialog = (): void => {
        this.onClose();
        this.sendPayment({ label: 'close' });
    };

    render() {
        const { id, link = null, retry = null, subscription, renew = false, onDmrResizeEvent, isMobile, source = '' } = this.props;

        if (subscription.hasTrial && !renew) {
            return <BuyModalTrial id={id} link={link} retry={retry} onClose={this.onClose} onSuccess={this.onSuccess} source={source} />;
        }

        return (
            <Dialog
                id="tariff-buy"
                open
                size="big"
                header={this.renderHeader()}
                onCancel={this.onCancelDialog}
                mod={isMobile ? 'mobile' : 'frame_vkpay'}
                dimmer={!isMobile}
            >
                <BuyContent
                    id={id}
                    link={link}
                    retry={retry}
                    renew={renew}
                    source={source}
                    onClose={this.onClose}
                    onSuccess={this.onSuccess}
                    onBuyClick={this.onBuyClick}
                    onDmrResizeEvent={onDmrResizeEvent}
                />
            </Dialog>
        );
    }
}

export const BuyModal = connect(mapStateToProps)(BuyModalComponent);
